module.exports = __webpack_public_path__ + "static/burg-icon-79b18a5d205cdebc264fc06817b73584.png";